
import { useEffect, useState, useMemo, useRef } from 'react';
import close from '../../../assets/icons/close.svg';
import next from '../../../assets/icons/icon.svg';
import useAutoFocus from '../../../Utils/autoFocus';
import Select from 'react-select';
import { reactSelectStyles } from '../../../Utils/selectBoxStyle';
import { getData, Postdata, Postdataform } from '../../../API/GlobalApi';
import '../../../assets/css/Modal.css';
import { useNavigate, useParams } from 'react-router-dom';
import Notifier from '../../../Utils/notify';
import ConfirmationModal from '../../../Component/Modals/ConfirmationModal';
import '../../../assets/css/Modal.css'

const SelectStudents = ({ onNext, editId }) => {



    const { id } = useParams();
    const [planMode, setPlanMode] = useState("course");
    const [showDueOnly, setShowDueOnly] = useState(false);
    const [selectedRows, setSelectedRows] = useState({});
    const [balanceToggle, setBalanceToggle] = useState({});
    const [courseData, setCourseData] = useState([]);
    const [courseOptions, setCourseOptions] = useState([]);
    const [semesterOptions, setSemesterOptions] = useState([]);
    const [sectionOptions, setSectionOptions] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState([]);
    const [selectedSemester, setSelectedSemester] = useState([]);
    const [selectedSections, setSelectedSections] = useState([]);
    const [allCourseStudents, setAllCourseStudents] = useState([]);
    const [students, setStudents] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    // --- Edit mode: add students to an existing activity ---------------------
    // Deliberately separate state from the create-mode picker: picking a course
    // there auto-selects every student, which would make it far too easy to add
    // hundreds of students to a live activity by accident.
    const [enrollment, setEnrollment] = useState(null);
    const [addSelectedIds, setAddSelectedIds] = useState([]);
    const [addSearch, setAddSearch] = useState("");
    const [addCourse, setAddCourse] = useState([]);
    const [addSemester, setAddSemester] = useState([]);
    const [addingStudents, setAddingStudents] = useState(false);
    // { ids, noun } for the pending add awaiting confirmation
    const [pendingAdd, setPendingAdd] = useState(null);
    const [selectedFeeHeads, setSelectedFeeHeads] = useState([]);
    const [showStudents, setShowStudents] = useState(false);
    const [studentResponse, setStudentResponse] = useState('')
    const [helpdeskperson, setHelpDeskPerson] = useState([]);
    const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
    const [assignedEmployees, setAssignedEmployees] = useState([]); // employee IDs
    const [selectedActivityType, setSelectedActivityType] = useState(null);
    const [activityTypeOptions, setActivityTypeOptions] = useState([]);




    const gethelpdeskPerson = async () => {
        const url = "staff/unpaginated-employee-list/";
        const response = await getData(url);
        setAssignedEmployees(response?.employees)

    }


    const getActivityEventsData = async () => {
        try {
            const response = await getData("academics/events/");

            const options = response?.map(ev => ({
                value: ev.id,     // send to backend
                label: ev.name,   // show in UI
            })) || [];

            setActivityTypeOptions(options);
        } catch (error) {
            console.error("Failed to fetch activity types", error);
        }
    };

    useEffect(() => {
        gethelpdeskPerson()
        getActivityEventsData()
    }, [])
    const [accordion, setAccordion] = useState({
        acc1: true,
        acc2: true,
        accAuth: true,
        acc3: true,
        acc4: true,
        acc5: true,
        acc6: true
    });

    const toggle = (key) => {
        setAccordion((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const today = new Date().toISOString().split("T")[0]; // yyyy-mm-dd

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [examStartDate, setExamStartDate] = useState("");


    const [activityName, setActivityName] = useState('');
    const [subjectName, setSubjectName] = useState('');
    const [description, setDescription] = useState('');
    const [authMethods, setAuthMethods] = useState([]); // e.g., ['OTP','Biometric']
    const [preChecks, setPreChecks] = useState([]);    // e.g., ['NOC Clearance']
    // Authentication checkboxes
    const toggleAuthMethod = (method) => {
        setAuthMethods((prev) =>
            prev.includes(method)
                ? prev.filter((m) => m !== method)
                : [...prev, method]
        );
    };

    // Pre-checks
    const togglePreCheck = (check) => {
        setPreChecks((prev) =>
            prev.includes(check)
                ? prev.filter((c) => c !== check)
                : [...prev, check]
        );
    };
    const [sessions, setSessions] = useState([]);
    const [selectedSession, setSelectedSession] = useState(null);



    const [loadingData, setLoadingData] = useState(false);
    const [loading, setLoading] = useState(false);
    // Roster + the students holding an admit card for this activity who are not
    // on it. Those cards cannot be sent or served until the student is enrolled:
    // every delivery path starts with `student not in activity.students.all()`.
    const loadEnrollment = async () => {
        if (!editId) return;
        try {
            const res = await getData(`academics/activities/${editId}/enrollment/`);
            if (res && !res.error) setEnrollment(res);
        } catch (err) {
            console.error('Failed to load activity enrollment', err);
        }
    };

    useEffect(() => { loadEnrollment(); }, [editId]);

    const addStudentsToActivity = async (ids, successNoun) => {
        if (!ids.length) return;
        setAddingStudents(true);
        try {
            const res = await Postdata(`academics/activities/${editId}/add-students/`, {
                student_ids: ids.join(','),
            });
            if (res?.error) {
                Notifier.error(res.error);
                return;
            }
            const added = res?.added_count ?? 0;
            const already = res?.already_enrolled_count ?? 0;
            Notifier.success(
                `${added} ${successNoun} added.` + (already ? ` ${already} were already on the roster.` : '')
            );
            setAddSelectedIds([]);
            await loadEnrollment();
        } catch (err) {
            Notifier.error('Failed to add students to this activity');
        } finally {
            setAddingStudents(false);
        }
    };

    // Adding takes effect immediately - it is not part of the Update Activity
    // save - so confirm before writing.
    const handleAddUnrostered = () => {
        const ids = (enrollment?.unrostered_admit_card_students || []).map(s => s.student_id);
        if (ids.length) setPendingAdd({ ids, noun: 'admit card holder(s)' });
    };

    const handleAddSelectedStudents = () => {
        if (addSelectedIds.length) setPendingAdd({ ids: [...addSelectedIds], noun: 'student(s)' });
    };

    const confirmPendingAdd = async () => {
        if (!pendingAdd) return;
        const { ids, noun } = pendingAdd;
        await addStudentsToActivity(ids, noun);
        setPendingAdd(null);
    };

    // Every student in the loaded academic year, flattened straight from
    // courseData. The create-mode flattening bails out on
    // `if (!selectedCourse.length) return`, and selectedCourse is always empty
    // in edit mode - so this picker cannot reuse allCourseStudents.
    const allSessionStudents = useMemo(() => {
        if (!editId || !courseData.length) return [];
        const out = [];
        courseData.forEach(course => {
            course.academic_groups?.forEach(semester => {
                semester.lags?.forEach(section => {
                    section.students?.forEach(stu => {
                        out.push({
                            id: stu.user_id,
                            name: stu.full_name,
                            rollNumber: stu.permanent_registration_number,
                            mobile: stu.mobile_number || stu.mobile || '',
                            email: stu.email || '',
                            semester: semester.id,
                            semesterName: semester.name,
                            section: section.id,
                            sectionName: section.name,
                            courseId: course.id,
                            courseName: course.full_name,
                        });
                    });
                });
            });
        });
        return out;
    }, [editId, courseData]);

    // Semesters for the picker, grouped by course and narrowed to the selected
    // courses. An activity may span courses, so both selects are multi.
    const addSemesterOptions = useMemo(() => {
        if (!editId || !courseData.length) return [];
        const courseIds = (addCourse || []).map(c => c.value);
        return courseData
            .filter(course => !courseIds.length || courseIds.includes(course.id))
            .map(course => ({
                label: course.full_name,
                options: (course.academic_groups || []).map(sem => ({
                    value: sem.id,
                    label: `${course.full_name} - ${sem.name}`,
                })),
            }))
            .filter(group => group.options.length);
    }, [editId, courseData, addCourse]);

    // The picker starts empty and is driven by the filters: listing every student
    // in the session by default is thousands of rows and invites an accidental
    // "select all".
    const addFiltersApplied = useMemo(
        () => Boolean((addCourse || []).length || (addSemester || []).length || addSearch.trim()),
        [addCourse, addSemester, addSearch]
    );

    // Candidates for the chosen filters, always minus whoever is already on the
    // activity - a student cannot be added twice.
    const addCandidates = useMemo(() => {
        if (!editId || !addFiltersApplied) return [];
        const rostered = new Set((enrollment?.roster || []).map(s => s.student_id));
        const courseIds = (addCourse || []).map(c => c.value);
        const semesterIds = (addSemester || []).map(s => s.value);
        const q = addSearch.trim().toLowerCase();
        return allSessionStudents.filter(stu => {
            if (rostered.has(stu.id)) return false;
            if (courseIds.length && !courseIds.includes(stu.courseId)) return false;
            if (semesterIds.length && !semesterIds.includes(stu.semester)) return false;
            if (!q) return true;
            return [stu.name, stu.rollNumber, stu.mobile, stu.email]
                .some(v => (v || '').toString().toLowerCase().includes(q));
        });
    }, [editId, addFiltersApplied, allSessionStudents, enrollment, addCourse, addSemester, addSearch]);

    // Drop any selection that the current filters no longer show, so the count
    // and the Add button can never act on rows the operator cannot see.
    useEffect(() => {
        setAddSelectedIds(prev => {
            const visible = new Set(addCandidates.map(s => s.id));
            const next = prev.filter(id => visible.has(id));
            return next.length === prev.length ? prev : next;
        });
    }, [addCandidates]);

    const getActivityData = async () => {
        if (!editId) return;
        setLoadingData(true);

        try {
            const res = await getData(`academics/activities/update/?activity_id=${editId}`);
            if (!res) return;
            const firstStudent = res.students?.[0] || {};
            setActivityName(res.activity_name || "");
            setSubjectName(res?.practical_subject)
            setDescription(res.description || "");
            setStartDate(res.start_date || "");
            setExamStartDate(res.exam_start_date || "");
            setEndDate(res.end_date || "");
            // setAmount(res.amount || "");
            // setIsRefundable(res.amount_refundable === 1);

            /* ------------------------------------------------------------------
               1️⃣  PRE-CHECKS (Update Mode)
            ------------------------------------------------------------------ */
            if (Array.isArray(res.pre_check_methods)) {
                const preCheckReverseMap = {
                    1: "No Dues Clearance",
                    2: "NOC Clearance",
                    3: "Library NOC Clearance",
                };

                const mappedPreChecks = res.pre_check_methods
                    .map(item => {
                        if (!item) return null;

                        if (typeof item === "string") return item;         // "NOC Clearance"
                        if (typeof item === "number") return preCheckReverseMap[item]; // 3 => Library NOC Clearance
                        if (typeof item === "object") return item.name;    // {id:3,name:"Library NOC Clearance"}

                        return null;
                    })
                    .filter(Boolean);

                setPreChecks(mappedPreChecks);
            }

            /* ------------------------------------------------------------------
               2️⃣  AUTHENTICATION METHODS (Update Mode)
            ------------------------------------------------------------------ */
            if (Array.isArray(res.authentication_methods)) {
                const authReverseMap = {
                    1: "OTP",
                    2: "Biometric",
                };

                const mappedAuth = res.authentication_methods
                    .map(item => {
                        if (!item) return null;

                        if (typeof item === "string") return item;         // "OTP"
                        if (typeof item === "number") return authReverseMap[item]; // 1 => OTP
                        if (typeof item === "object") return item.name;    // {id:1,name:"OTP"}

                        return null;
                    })
                    .filter(Boolean);

                setAuthMethods(mappedAuth);
            }

            /* ------------------------------------------------------------------
               3️⃣  Employees
            ------------------------------------------------------------------ */
            if (res.employee_list?.length > 0 && selectedEmployeeIds.length === 0) {
                setSelectedEmployeeIds(res.employee_list.map(emp => emp.employee_id));
            }
            // 🔹 Sync activity type ONLY if options are already loaded
            // if (res.academic_event_type && activityTypeOptions.length) {
            //     const matched = activityTypeOptions.find(
            //         opt => opt.value === res.academic_event_type
            //     );
            //     setSelectedActivityType(matched || null);
            // }
            if (res.academic_event_type) {
                setSelectedActivityType({
                    value: res.academic_event_type.id,
                    label: res.academic_event_type.name,
                });
            }



            /* ------------------------------------------------------------------
               4️⃣  Load first student (step 2)
            ------------------------------------------------------------------ */
            if (firstStudent.student_id) {
                onNext({ student_ids: [firstStudent.student_id] });
            }
        } catch (e) {
            console.error("Error fetching activity data:", e);
        } finally {
            setLoadingData(false);
        }
    };



    useEffect(() => {
        if (editId) getActivityData();
    }, [editId]);




    const getSessions = async () => {
        const response = await getData("academics/academic-years/");


        const options = response?.map((session) => ({
            value: session.id,
            label: session.name,
            is_current: session.is_current,
        }));

        setSessions(options);

        // Find the default session where is_current is true
        const currentSession = options.find((opt) => opt.is_current);

        if (currentSession) {
            setSelectedSession(currentSession);
        }
    };

    useEffect(() => {

        getSessions();
    }, []);

    // Fetch specialization list whenever selectedSession changes
    useEffect(() => {
        if (!selectedSession) return;
        // Reset state immediately when session changes
        setSelectedCourse([]);
        setSelectedSemester([]);
        setSelectedSections([]);
        setSemesterOptions([]);
        setSectionOptions([]);
        setStudents([]);
        setAllCourseStudents([]);
        setSelectedStudent([]);
        setShowStudents(false);
        const fetchData = async () => {
            const query = `?academic_year_id=${selectedSession.value}`;
            const res = await getData(`finance/specializations/${query}`);

            if (Array.isArray(res)) {
                setCourseData(res);
                setCourseOptions(res.map((c) => ({ value: c.id, label: c.full_name })));
            }


        };

        fetchData();
    }, [selectedSession]);


    useEffect(() => {
        if (!selectedCourse.length || !courseData.length) return;

        let groupedSemesters = [];
        let allStudents = [];

        selectedCourse.forEach(courseOpt => {
            const course = courseData.find(c => c.id === courseOpt.value);
            if (!course?.academic_groups) return;

            const semesterOptions = course.academic_groups.map(sem => ({
                value: sem.id,
                label: `${course.full_name} - ${sem.name}`,  // ✅ show course + semester
                courseId: course.id,
                courseName: course.full_name
            }));


            groupedSemesters.push({
                label: course.full_name, // Group header (e.g. B.A)
                options: semesterOptions // Grouped semesters
            });

            // Collect students as before
            course.academic_groups.forEach(semester => {
                semester.lags?.forEach(section => {
                    section.students?.forEach(stu => {
                        allStudents.push({
                            id: stu.user_id,
                            name: stu.full_name,
                            rollNumber: stu.permanent_registration_number,
                            semester: semester.id,
                            semesterName: semester.name,
                            section: section.id,
                            sectionName: section.name,
                            courseId: course.id,
                            balance: stu.balance,
                            courseName: course.full_name,
                            feeSchedules: stu.fee_schedules || []
                        });
                    });
                });
            });
        });

        setSemesterOptions(groupedSemesters); // ✅ grouped options
        setAllCourseStudents(allStudents);
        setStudents(allStudents);
        setSelectedStudent(allStudents.map(s => s.id));
        // setShowStudents(true);
    }, [selectedCourse, courseData]);



    // 🔹 Sections depend on semester
    useEffect(() => {
        if (!selectedSemester.length) {
            setSectionOptions([]);
            setSelectedSections([]);
            setStudents(allCourseStudents);
            return;
        }

        let groupedSections = [];

        selectedSemester.forEach((semOpt) => {
            courseData.forEach((course) => {
                const semesterData = course.academic_groups?.find((s) => s.id === semOpt.value);

                if (semesterData?.lags?.length) {
                    const sectionOptions = semesterData.lags.map((sec) => ({
                        value: sec.id,
                        label: `${course.full_name} - ${semesterData.name} - ${sec.name}`,  // ✅ show course + semester + section
                        semesterId: semesterData.id,
                        semesterName: semesterData.name,
                        courseId: course.id,
                        courseName: course.full_name,
                    }));

                    // group label: "B.A - Semester 1"
                    groupedSections.push({
                        label: `${course.full_name} - ${semesterData.name}`,
                        options: sectionOptions,
                    });
                }
            });
        });

        setSectionOptions(groupedSections);
        setSelectedSections([]);

        // ✅ Auto-filter students for selected semesters
        const semesterIds = selectedSemester.map((s) => s.value);
        const filteredBySemester = allCourseStudents.filter((stu) =>
            semesterIds.includes(stu.semester)
        );
        setStudents(filteredBySemester);
        setSelectedStudent(filteredBySemester.map((s) => s.id));
    }, [selectedSemester, courseData, allCourseStudents]);



    // SECTION selection
    useEffect(() => {
        if (!selectedSections.length) {
            if (selectedSemester) {
                const filteredBySemester = allCourseStudents.filter(stu => stu.semester === selectedSemester.value);
                setStudents(filteredBySemester);
                // setSelectedStudent(filteredBySemester.map(s => s.id));
            } else {
                setStudents(allCourseStudents);
                // setSelectedStudent(allCourseStudents.map(s => s.id));
            }
            return;
        }

        const sectionIds = selectedSections.map(s => s.value);
        const filteredBySection = allCourseStudents.filter(stu => sectionIds.includes(stu.section));
        setStudents(filteredBySection);
        // setSelectedStudent(filteredBySection.map(s => s.id));
    }, [selectedSections, allCourseStudents, selectedSemester]);

    const filteredStudents = useMemo(() => {
        let result = [...allCourseStudents];

        const courses = selectedCourse || [];
        const semesters = selectedSemester || [];
        const sections = selectedSections || [];
        // const feeHeads = selectedFeeHeads || [];

        // 🔹 Filter by course
        if (courses.length) {
            const courseIds = courses.map(c => Number(c.value));
            result = result.filter(stu => courseIds.includes(stu.courseId));
        }

        // 🔹 Filter by semester
        if (semesters.length) {
            const semesterIds = semesters.map(s => Number(s.value));
            result = result.filter(stu => semesterIds.includes(stu.semester));
        }

        // 🔹 Filter by section
        if (sections.length) {
            const sectionIds = sections.map(s => s.value);
            result = result.filter(stu => sectionIds.includes(stu.section));
        }

        // 🔹 Filter by fee heads (new logic)
        // if (feeHeads.length) {
        //     result = result.filter(stu => {
        //         // check if any of student's feeSchedules match selected fee heads
        //         return stu.feeSchedules?.some(fee => feeHeads.includes(Number(fee.fee_type_head_pk)));
        //     });
        // }

        // 🔹 Filter by search term
        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            result = result.filter(stu =>
                stu.name?.toLowerCase().includes(term) ||
                stu.rollNumber?.toLowerCase().includes(term) ||
                stu.mobile_number?.toString().includes(term) ||
                stu.email?.toLowerCase().includes(term)

            );
        }

        return result;
    }, [allCourseStudents, selectedCourse, selectedSemester, selectedSections, selectedFeeHeads, searchTerm]);


    const calculateSelectedAmount = (student) => {
        return (student.feeSchedules || [])
            .filter(fs => selectedFeeHeads.includes(Number(fs.fee_type_head_pk)))
            .reduce((sum, fs) => sum + parseFloat(fs.amount || 0), 0)
            .toFixed(2);
    };
    const toggleAll = (e, studentsToSelect) => {
        if (e.target.checked) {
            const selectableIds = studentsToSelect.map(s => s.id);
            setSelectedStudent(selectableIds);

        } else {
            setSelectedStudent([]);

        }
    };

    // 🔐 Activity defaults (UI independent)
    const ACTIVITY_SECURITY_CONFIG = {
        authentication_method_ids: {
            OTP: 1,
            BIOMETRIC: 2,
        },
        pre_check_method_ids: {
            NO_DUES: 1,
            NOC: 2,
            LIBRARY_NOC: 3,
        },

        // ✅ Defaults always sent when UI is hidden
        defaultAuthentication: ['OTP'],          // only OTP
        defaultPreChecks: ['NO_DUES', 'LIBRARY_NOC'],
    };

    const authentication_method_ids =
        ACTIVITY_SECURITY_CONFIG.defaultAuthentication
            .map(key => ACTIVITY_SECURITY_CONFIG.authentication_method_ids[key])
            .join(',');

    const pre_check_method_ids =
        ACTIVITY_SECURITY_CONFIG.defaultPreChecks
            .map(key => ACTIVITY_SECURITY_CONFIG.pre_check_method_ids[key])
            .join(',');

    const handleCalculativeSubmit = async () => {
        // if (!activityName?.trim()) {
        //     Notifier.error("Activity name is required");
        //     return;
        // }

        const finalActivityName = activityNameAuto?.trim() || activityName?.trim();

        if (!startDate || !endDate) {
            Notifier.error("Activity timeline is required");
            return;
        }
        // Add validation after selectedStudent check
        if (selectedActivityType?.label?.includes("Practical") && !subjectName?.trim()) {
            Notifier.error("Please enter subject name");
            return;
        }
        if (!selectedEmployeeIds.length) {
            Notifier.error("Please assign at least one employee");
            return;
        }

        if (!selectedActivityType) {
            Notifier.error("Please select activity type");
            return;
        }

        if (!selectedStudent.length) {
            Notifier.error("Please select at least one student");
            return;
        }


        // ✅ Only selected + visible students
        const studentIds = selectedStudent.filter(id =>
            filteredStudents.some(stu => stu.id === id)
        );

        if (!studentIds.length) {
            Notifier.error("Please select at least one student");
            return;
        }
        setLoading(true); // start loader
        const payload = {
            // 🔹 Activity details
            activity_name: finalActivityName,
            activity_event_type: selectedActivityType?.value || null,
            start_date: startDate,
            end_date: endDate,
            exam_start_date: examStartDate || null,

            // 🔹 Assignment
            employee_ids: selectedEmployeeIds.join(','),

            // 🔹 Students
            student_ids: studentIds.join(','),

            // 🔹 Semester / LAG
            lag_ids: selectedSemester?.map(s => s.value).join(',') || null,
            // authentication_method_ids: authMethods
            //     .map(m => (m === 'OTP' ? 1 : 2))      // map to API IDs
            //     .join(','),
            // pre_check_method_ids: preChecks
            //     .map(c => {
            //         if (c === "NOC Clearance") return 2;
            //         if (c === "No Dues Clearance") return 1;
            //         if (c === "Library NOC Clearance") return 3;  // ✅ Add this
            //         return null;
            //     })
            //     .filter(Boolean)
            //     .join(','),

            // 🔐 Controlled from ONE place
            authentication_method_ids,
            pre_check_method_ids,
            // ✅ Add practical subject only if Practical is selected
            ...(selectedActivityType?.label?.includes("Practical") && {
                practical_subject: subjectName?.trim()
            }),
        };

        console.log("FINAL PAYLOAD 👉", payload);

        // onNext(payload);

        try {
            const res = await Postdata("academics/activities/", payload);

            console.log("res of activity creation", res);
            if (res?.id) {
                Notifier.success("Activity Created Successfully!");
                navigate(-1)

            } else {
                const errorMsg =
                    // res?.description?.[0] ||
                    res?.error ||
                    res?.message ||
                    "Failed to create activity. Please try again.";

                Notifier.error(errorMsg);
            }
            // SUCCESS NOTIFIER




        } catch (error) {
            console.error("Activity Creation Error:", error);

            // ERROR NOTIFIER
            Notifier.error(
                error?.response?.data?.message ||
                "Failed to create activity. Please try again."
            );
        } finally {
            setLoading(false); // stop loader
        }
    };



    const handleUpdate = async () => {
        if (!editId) return; // nothing to update if no editId

        const isPractical = selectedActivityType?.label?.includes("Practical");

        // ✅ Validate subject name for Practical
        if (isPractical && !subjectName?.trim()) {
            Notifier.error("Please enter subject name for Practical activity");
            return;
        }
        const authMap = {
            OTP: 1,
            Biometric: 2
        };

        const preCheckMap = {
            "No Dues Clearance": 1,
            "NOC Clearance": 2,
            "Library NOC Clearance": 3
        };

        setLoading(true);

        const payload = {
            activity_id: editId, // include the activity ID
            activity_name: activityName,
            description,
            start_date: startDate,
            end_date: endDate,
            exam_start_date: examStartDate,
            activity_event_type: selectedActivityType?.value || null,

            // ✅ Add practical subject only if Practical is selected
            ...(selectedActivityType?.label?.includes("Practical") && {
                practical_subject: subjectName?.trim()
            }),
            // amount: amount || null,
            // is_amount_refundable: isRefundable ? 1 : 0,
            employee_ids: selectedEmployeeIds.join(','), // comma-separated string
            // ✔️ Authentication method IDs
            authentication_method_ids: authMethods
                .map(name => authMap[name])
                .filter(Boolean)
                .join(","),

            // ✔️ Pre-check method IDs
            pre_check_method_ids: preChecks
                .map(name => preCheckMap[name])
                .filter(Boolean)
                .join(","),
        }



        try {
            const res = await Postdata('academics/activities/update/', payload);
            console.log("response", res);

            if (res?.error) {
                Notifier.error(res.error);
            } else if (res?.message) {
                Notifier.success(res?.message || 'Activity updated successfully!');
                navigate("/manage-activities"); // optional
            } else {
                // fallback if API returns something unexpected
                Notifier.error('Unexpected response from server');
            }
        } catch (error) {
            console.error('Activity Update Error:', error);
            Notifier.error(
                error?.response?.data?.message || 'Failed to update activity. Please try again.'
            );
        } finally {
            setLoading(false);
        }

    };




    const navigate = useNavigate()
    const displayedStudents = showDueOnly
        ? filteredStudents.filter(s => s.balance < 0)
        : filteredStudents;

    // ✅ Filter only selected + visible
    const studentIds = selectedStudent.filter(id =>
        filteredStudents.some(stu => stu.id === id)
    );



    const activityNameAuto = (() => {
        const isAllSelected =
            selectedStudent.length > 0 &&
            selectedStudent.filter(id =>
                filteredStudents.some(stu => stu.id === id)
            ).length === filteredStudents.length;

        // ⛔ if not all selected → manual value
        if (!isAllSelected) return activityName;

        const sectionPart = selectedSections.length
            ? selectedSections.map(sec => sec.label).join(", ")
            : null;

        const semesterPart = selectedSemester.length
            ? selectedSemester.map(sem => sem.label).join(", ")
            : null;

        const coursePart = selectedCourse.length
            ? selectedCourse.map(course => course.label).join(", ")
            : null;

        const basePart = sectionPart || semesterPart || coursePart;

        // nothing selected → reset
        if (!basePart) return "";

        // ✅ add "- All" only when section is NOT selected
        const suffix = selectedSections.length ? "" : " - All";

        return `${basePart}${suffix}`;
    })();


    const isAllFilteredSelected =
        selectedStudent.length > 0 &&
        selectedStudent.filter(id =>
            filteredStudents.some(stu => stu.id === id)
        ).length === filteredStudents.length;

    const isPractical = selectedActivityType?.label?.includes("Practical");

    const finalActivityName = activityNameAuto?.trim() || activityName?.trim();

    const isDisabled =
        !finalActivityName ||
        !selectedStudent?.length ||
        !selectedEmployeeIds?.length ||
        !startDate ||
        !endDate ||
        (isPractical && !subjectName?.trim()); // ✅ subject required only for Practical



    useEffect(() => {
        if (!selectedCourse.length) {
            setActivityName("");
        }
    }, [selectedCourse]);

    return (
        <>

            <div style={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
                overflow: "hidden",
            }}>
                <div style={{ flexShrink: 0, padding: "0 12px" ,display:'flex',alignItems:'center',gap:'10px'}}>
                    <button
                        onClick={() => navigate(-1)}
                        style={{ background: "transparent", border: "none", cursor: "pointer", padding: 0 }}
                        title="Go back"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            fill="none"
                            stroke="#7F56DA"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <line x1="19" y1="12" x2="5" y2="12"></line>
                            <polyline points="12 19 5 12 12 5"></polyline>
                        </svg>
                    </button>
                    <h2 className='main-heading' style={{ margin: 0, color: "#7F56DA" }}>{editId ? "Edit" : "Create"} Activity</h2>
                </div>
                <div
                    className='scheduleconainer'
                    style={{
                        flex: 1,
                        overflowY: "auto",
                        overflowX: "hidden",
                        minHeight: 0,
                        padding: "20px",
                        paddingBottom:'30px',
                        scrollbarGutter: "stable",
                    }}>
                    <div className="row">
                        <div className='col-md-12'>
                            <div className="row mt-3 d-flex justify-content-start align-items-center">
                                <div className="col-md-3">
                                    <label className="form-labell">
                                        Activity Type <span className="astrisk">*</span>
                                    </label>

                                    <Select
                                        value={selectedActivityType}
                                        onChange={setSelectedActivityType}
                                        options={activityTypeOptions}
                                        styles={reactSelectStyles}
                                        placeholder="Select Activity Type"
                                        isClearable
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                    />

                                </div>

                                {!editId && (<div className="col-md-3">
                                    <label className="form-labell">Select Course <span className="astrisk">*</span></label>
                                    <Select
                                        value={selectedCourse}
                                        onChange={(opt) => setSelectedCourse(opt)}
                                        options={courseOptions}
                                        styles={reactSelectStyles}
                                        placeholder="Select Course"
                                        isClearable
                                        menuPortalTarget={document.body}   // 🔹 Render menu at body level
                                        menuPosition="fixed"
                                        isMulti
                                    />
                                </div>)}
                                {/* Semesters select (multi) - depends on selectedCourse */}
                                {!editId && (<div className="col-md-3">
                                    <label className="form-labell">Select Semester<span className="astrisk">*</span></label>
                                    <Select
                                        value={selectedSemester}               // for multi-select, this should be an array
                                        onChange={(options) => setSelectedSemester(options || [])} // store array of selected semesters
                                        options={semesterOptions}              // ✅ grouped by course
                                        styles={reactSelectStyles}
                                        placeholder="Select Semester"
                                        isDisabled={!selectedCourse.length}

                                        isMulti                                // ✅ enable multi-select
                                        // isDisabled={!semesterOptions.length}
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                        formatGroupLabel={(group) => (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    fontWeight: 700,
                                                    fontSize: '15px',
                                                    color: '#222',
                                                    // background: '#f3f3f3',
                                                    padding: '6px 10px',
                                                    borderBottom: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                }}
                                            >
                                                {group.label}
                                                {/* <span style={{ fontSize: '12px', color: '#666' }}>
                                                ({group.options.length})
                                            </span> */}
                                            </div>
                                        )}
                                    />

                                </div>)}
                                {/* Toggle Tabs */}

                                {/* Sections select (multi) - depends on selectedSemesters */}
                                {!editId && (<div className="col-md-3">
                                    <label className="form-labell">Select Section(s) <span className="astrisk">*</span></label>
                                    <Select
                                        value={selectedSections}
                                        onChange={(options) => setSelectedSections(options || [])}
                                        options={sectionOptions} // ✅ grouped
                                        styles={reactSelectStyles}
                                        placeholder="Select Section"
                                        isMulti
                                        isDisabled={!sectionOptions.length}
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                        formatGroupLabel={(group) => (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    fontWeight: 700,
                                                    fontSize: '15px',
                                                    color: '#222',
                                                    // background: '#f3f3f3',
                                                    padding: '6px 10px',
                                                    borderBottom: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                }}
                                            >
                                                {group.label}
                                                {/* <span style={{ fontSize: '12px', color: '#666' }}>
                                                ({group.options.length})
                                            </span> */}
                                            </div>
                                        )}
                                    />


                                </div>)}
                            </div>
                        </div>
                    </div>

                    <div className=' '>
                        {!selectedCourse ? (
                            <div className="col-12 d-flex flex-column align-items-center justify-content-center mt-5"
                                style={{ minHeight: 420, textAlign: 'center', color: '#6c757d' }} >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="80"
                                    height="80"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#6c757d"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <path d="M21 21l-4.35-4.35"></path>
                                    <circle cx="10" cy="10" r="7"></circle>
                                    <line x1="14" y1="10" x2="14" y2="10"></line>
                                </svg>
                                <p className="mt-3" style={{ fontSize: '18px', fontWeight: 500 }}>
                                    No records found
                                </p>
                                <p className="text-muted" style={{ fontSize: '14px' }}>
                                    Please select a course to view students.
                                </p>
                            </div>
                        ) : (
                            <>
                                <div className="row mt-3">
                                    {!editId && (<div className="col-md-12 d-flex align-items-center gap-2 mt-3 mb-3 justify-content-between">
                                        <div className="form-check form-switch custom-switch d-flex justify-content-center gap-3  align-items-center">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                style={{ cursor: 'pointer' }}
                                                checked={showStudents} // controlled by state
                                                onChange={() => setShowStudents(prev => !prev)} // toggle
                                            />
                                            <label className="form-check-label">
                                                {showStudents ? "Hide Student List" : "Show Student List"}
                                            </label>
                                        </div>
                                        {/* <p className="" style={{ color: '#7F56DA' }}>
                                            Academic Year: {selectedSession?.label || "-"}
                                        </p> */}

                                    </div>)}
                                </div>
                                <div className="row mt-4">
                                    {showStudents && (
                                        <div className="col-12">
                                            <div className="mt-4 d-flex justify-content-between align-items-center">
                                                <h5>
                                                    Select Students{" "}
                                                    <span className="text-muted small" style={{ fontSize: "14px" }}>
                                                        (
                                                        {
                                                            selectedStudent.filter(id =>
                                                                filteredStudents.some(stu => stu.id === id)
                                                            ).length
                                                        }
                                                        / {filteredStudents.length} selected)
                                                    </span>
                                                </h5>
                                            </div>
                                            <div className="feePlanTableContainer mt-3" style={{ maxHeight: '400px', overflowY: 'auto', flexShrink: '0' }}>
                                                <table className="table table-bordered mt-2 feeplantables">
                                                    <thead
                                                        style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}
                                                    >
                                                        <tr>
                                                            {/* Master checkbox */}

                                                            <th style={{ width: 40 }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={
                                                                        (showDueOnly
                                                                            ? filteredStudents.filter(s => s.balance < 0).length > 0
                                                                            : filteredStudents.length > 0) &&
                                                                        selectedStudent.length ===
                                                                        (showDueOnly
                                                                            ? filteredStudents.filter(s => s.balance < 0).length
                                                                            : filteredStudents.length)
                                                                    }
                                                                    onChange={(e) =>
                                                                        toggleAll(
                                                                            e,
                                                                            showDueOnly
                                                                                ? filteredStudents.filter(s => s.balance < 0)
                                                                                : filteredStudents
                                                                        )
                                                                    }
                                                                />
                                                            </th>
                                                            {/* Student name + search */}
                                                            <th
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    gap: '8px',
                                                                    justifyContent: 'space-between'
                                                                }}
                                                            >
                                                                Student Name (Registration No.)
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Search students by name,registraion number,mobile number.."
                                                                    value={searchTerm}
                                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                                    style={{ maxWidth: '480px', height: '30px', fontSize: '14px', marginLeft: 'auto', }}
                                                                />
                                                            </th>

                                                            <th>Course</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {filteredStudents.length === 0 ? (
                                                            <tr style={{ height: "300px" }}  >
                                                                {/* Checkbox column */}

                                                                <td style={{ width: "2%" }}></td>

                                                                {/* Student column */}
                                                                <td
                                                                    className="text-center text-muted py-4"
                                                                    style={{ width: "50%" }}
                                                                >
                                                                    No students found for the selected filters.
                                                                </td>

                                                                {/* Course column – width preserved */}
                                                                <td style={{ width: "30%" }}></td>


                                                            </tr>
                                                        ) : (
                                                            filteredStudents.map((s) => (
                                                                <tr key={s.id}>

                                                                    <td>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedStudent.includes(s.id)}
                                                                            onChange={(e) => {
                                                                                if (e.target.checked) {
                                                                                    setSelectedStudent([...selectedStudent, s.id]);
                                                                                } else {
                                                                                    setSelectedStudent(selectedStudent.filter(id => id !== s.id));

                                                                                }
                                                                            }}
                                                                        />

                                                                    </td>
                                                                    <td>{s.name} ({s.rollNumber})</td>

                                                                    <td>{s?.courseName} | {s.semesterName} | {s.sectionName}</td>

                                                                </tr>
                                                            ))
                                                        )}
                                                    </tbody>




                                                </table>

                                            </div>
                                        </div>)}
                                </div>
                            </>
                        )}
                        {selectedActivityType?.label?.includes("Practical") && (
                            <div className="card mb-2 mt-4">
                                <button
                                    className="card-header text-left activityCardHeader  d-flex justify-content-between align-items-center"
                                    data-toggle="collapse"
                                    data-target="#acc1"
                                    aria-expanded={accordion.acc1}
                                // onClick={() => toggle("acc1")}
                                >
                                    <strong>Subject Details</strong>
                                    {/* <span className="acc-icon">
                                {accordion.acc1 ? "−" : "+"}
                            </span> */}
                                </button>

                                <div
                                    id="acc1"
                                    className={`collapse ${accordion.acc6 ? "show" : ""}`}
                                    data-parent="#accordion"
                                >

                                    <div className="card-body">
                                        <div className="form-group">
                                            <label className="form-labell">Subject Name<span className='astrisk'>*</span></label>
                                            <input type="text" className="form-control" placeholder="Home science"
                                                value={subjectName}
                                                onChange={(e) => setSubjectName(e.target.value)}
                                            />


                                        </div>

                                        {/* <div className="form-group">
                                    <label className="form-labell">Description</label>
                                    <textarea
                                        className="form-control" style={{ fontSize: '12px' }}
                                        rows="3"
                                        placeholder="Short description about this activity"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    ></textarea>
                                </div> */}

                                    </div>
                                </div>
                            </div>
                        )}

                        {editId && (
                        <div className="card mb-2 mt-4">
                            <button
                                className="card-header text-left activityCardHeader d-flex justify-content-between align-items-center"
                                data-toggle="collapse"
                                data-target="#accStudents"
                                aria-expanded={accordion.acc3}
                                onClick={() => toggle("acc3")}
                            >
                                <strong>Students {enrollment ? `(${enrollment.roster_count} on this activity)` : ''}</strong>
                                <span className="acc-icon">{accordion.acc3 ? "\u2212" : "+"}</span>
                            </button>

                            <div id="accStudents" className={`collapse ${accordion.acc3 ? "show" : ""}`}>
                                <div className="card-body">

                                    {/* Students holding an admit card for this activity but not on its roster */}
                                    {enrollment && enrollment.unrostered_admit_card_students.length === 0 && (
                                        <div className="alert alert-success py-2" style={{ borderRadius: 8 }}>
                                            <span className="small">
                                                Every admit card uploaded for this activity belongs to a student on it.
                                            </span>
                                        </div>
                                    )}

                                    {enrollment?.unrostered_admit_card_students?.length > 0 && (
                                        <div className="alert alert-warning" style={{ borderRadius: 8 }}>
                                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                                                <div style={{ maxWidth: '75%' }}>
                                                    <strong>
                                                        {enrollment.unrostered_admit_card_students.length} admit card
                                                        {enrollment.unrostered_admit_card_students.length === 1 ? '' : 's'} in this activity
                                                        belong to students who are not on it.
                                                    </strong>
                                                    <div className="text-muted small mt-1">
                                                        Their admit cards cannot be shared or downloaded until they are added.
                                                    </div>
                                                    <div className="small mt-1">
                                                        {enrollment.unrostered_admit_card_students.slice(0, 6).map(s => s.full_name).join(', ')}
                                                        {enrollment.unrostered_admit_card_students.length > 6
                                                            ? `, +${enrollment.unrostered_admit_card_students.length - 6} more` : ''}
                                                    </div>
                                                </div>
                                                <button className="add-btn" disabled={addingStudents} onClick={handleAddUnrostered}>
                                                    {addingStudents
                                                        ? <span className="spinner-border spinner-border-sm" role="status" />
                                                        : `Add all ${enrollment.unrostered_admit_card_students.length}`}
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    {/* Current roster */}
                                    <h6 className="mt-2">On this activity ({enrollment?.roster_count ?? 0})</h6>
                                    <div style={{ maxHeight: 160, overflowY: 'auto', border: '1px solid #eee', borderRadius: 6, padding: 8 }}>
                                        {enrollment?.roster?.length
                                            ? enrollment.roster.map(s => (
                                                <div key={s.student_id} className="small py-1">
                                                    {s.full_name} <span className="text-muted">({s.permanent_registration_number})</span>
                                                    <span className="text-muted"> — {s.course_name}</span>
                                                </div>))
                                            : <div className="text-muted small">No students yet.</div>}
                                    </div>

                                    {/* Add more students */}
                                    <h6 className="mt-4">Add students</h6>
                                    <div className="text-muted small mb-2">
                                        Students can come from any course. Newly added students get the same
                                        pre-checks and authentication steps as the students already on this activity.
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="form-labell">Course</label>
                                            <Select value={addCourse} onChange={(opt) => { setAddCourse(opt || []); setAddSemester([]); }}
                                                options={courseOptions} styles={reactSelectStyles} placeholder="All courses"
                                                isMulti isClearable menuPortalTarget={document.body} menuPosition="fixed" />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-labell">Semester</label>
                                            <Select value={addSemester} onChange={(opt) => setAddSemester(opt || [])}
                                                options={addSemesterOptions} styles={reactSelectStyles} placeholder="All semesters"
                                                isMulti isClearable menuPortalTarget={document.body} menuPosition="fixed" />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-labell">Search</label>
                                            <input type="text" className="form-control" value={addSearch}
                                                placeholder="Name, registration or mobile number"
                                                onChange={(e) => setAddSearch(e.target.value)} />
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <span className="text-muted small">
                                            {addFiltersApplied
                                                ? `${addSelectedIds.length} selected of ${addCandidates.length} available`
                                                : 'Choose a course, semester, or search to list students'}
                                        </span>
                                        <div className="d-flex gap-2">
                                            <button className="btn btn-sm btn-outline-secondary"
                                                disabled={!addCandidates.length}
                                                onClick={() => setAddSelectedIds(
                                                    addSelectedIds.length === addCandidates.length
                                                        ? [] : addCandidates.map(s => s.id))}>
                                                {addSelectedIds.length === addCandidates.length && addCandidates.length > 0
                                                    ? 'Clear all' : 'Select all shown'}
                                            </button>
                                            <button className="add-btn" disabled={!addSelectedIds.length || addingStudents}
                                                onClick={handleAddSelectedStudents}
                                                style={{ opacity: (!addSelectedIds.length || addingStudents) ? 0.5 : 1 }}>
                                                {addingStudents
                                                    ? <span className="spinner-border spinner-border-sm" role="status" />
                                                    : `Add ${addSelectedIds.length || ''} student${addSelectedIds.length === 1 ? '' : 's'}`}
                                            </button>
                                        </div>
                                    </div>

                                    <div style={{ maxHeight: 300, overflowY: 'auto', border: '1px solid #eee', borderRadius: 6, marginTop: 8 }}>
                                        <table className="table table-bordered mb-0 feeplantables">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: 40 }}></th>
                                                    <th>Student Name (Registration No.)</th>
                                                    <th>Course</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {addCandidates.length === 0 && (
                                                    <tr><td colSpan={3} className="text-muted text-center py-3">
                                                        {!addFiltersApplied
                                                            ? 'Pick a course or semester, or search by name, registration or mobile number.'
                                                            : allSessionStudents.length === 0
                                                                ? 'Loading students for this session...'
                                                                : 'No students match these filters. Anyone matching is already on this activity.'}
                                                    </td></tr>)}
                                                {addCandidates.slice(0, 300).map(stu => (
                                                    <tr key={stu.id}>
                                                        <td>
                                                            <input type="checkbox" checked={addSelectedIds.includes(stu.id)}
                                                                onChange={(e) => setAddSelectedIds(prev =>
                                                                    e.target.checked ? [...prev, stu.id] : prev.filter(id => id !== stu.id))} />
                                                        </td>
                                                        <td>{stu.name} ({stu.rollNumber})</td>
                                                        <td>{stu.courseName} | {stu.semesterName} | {stu.sectionName}</td>
                                                    </tr>))}
                                            </tbody>
                                        </table>
                                        {addCandidates.length > 300 && (
                                            <div className="text-muted small p-2">
                                                Showing the first 300 of {addCandidates.length}. Narrow the filters or search to see the rest.
                                            </div>)}
                                    </div>

                                </div>
                            </div>
                        </div>
                        )}

                        <ConfirmationModal
                            isOpen={Boolean(pendingAdd)}
                            title="Add students to this activity?"
                            isSubmitting={addingStudents}
                            onCancel={() => setPendingAdd(null)}
                            onConfirm={confirmPendingAdd}
                            message={
                                <>
                                    This will add <strong>{pendingAdd?.ids?.length || 0}</strong> student
                                    {pendingAdd?.ids?.length === 1 ? '' : 's'} to
                                    <strong> {activityName || 'this activity'}</strong> straight away.
                                    <br /><br />
                                    <strong>This happens immediately — you do not need to press “Update Activity”,
                                    and leaving the page will not undo it.</strong>
                                    <br /><br />
                                    Each student added gets the same pre-checks and authentication steps as the
                                    students already on this activity. Students cannot be removed from an activity
                                    once added.
                                </>
                            }
                        />

                        <div className="card mb-2 mt-4">
                            <button
                                className="card-header text-left activityCardHeader  d-flex justify-content-between align-items-center"
                                data-toggle="collapse"
                                data-target="#acc1"
                                aria-expanded={accordion.acc1}
                            // onClick={() => toggle("acc1")}
                            >
                                <strong>Activity Details</strong>
                                {/* <span className="acc-icon">
                                {accordion.acc1 ? "−" : "+"}
                            </span> */}
                            </button>

                            <div
                                id="acc1"
                                className={`collapse ${accordion.acc1 ? "show" : ""}`}
                                data-parent="#accordion"
                            >
                                <div className="card-body">
                                    <div className="form-group">
                                        <label className="form-labell">Activity Name<span className='astrisk'>*</span></label>
                                        <input type="text" className="form-control" placeholder="B.Ed. - Semester 3 - (10/1/2026 & Beyond)"
                                            value={activityNameAuto}
                                            onChange={(e) => setActivityName(e.target.value)}
                                            readOnly={isAllFilteredSelected}   // ✅ read-only only in this case
                                            style={{
                                                backgroundColor: isAllFilteredSelected ? "#f0f0f0" : "#fff", // gray if read-only
                                                color: isAllFilteredSelected ? "#555" : "#000",               // darker text for read-only
                                                cursor: isAllFilteredSelected ? "not-allowed" : "text"
                                            }}

                                        />
                                        <style>
                                            {`
                                .form-control::placeholder {
                                    color: #c7c7c7;
                                    opacity: 1;
                                }
                                `} </style>

                                    </div>

                                    {/* <div className="form-group">
                                    <label className="form-labell">Description</label>
                                    <textarea
                                        className="form-control" style={{ fontSize: '12px' }}
                                        rows="3"
                                        placeholder="Short description about this activity"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    ></textarea>
                                </div> */}

                                </div>
                            </div>
                        </div>
                        <div className="card mb-2">
                            <button
                                className="card-header text-left activityCardHeader"
                                data-toggle="collapse"
                                data-target="#acc2"
                                aria-expanded={accordion.acc2}
                            // onClick={() => toggle("acc2")}
                            >
                                <strong> Activity Timeline</strong>
                                {/* <span className="acc-icon">
                                {accordion.acc2 ? "−" : "+"}
                            </span> */}
                            </button>

                            <div
                                id="acc2"
                                className={`collapse ${accordion.acc2 ? "show" : ""}`}
                                data-parent="#accordion"
                            >
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <label className="form-labell">Start Date<span className='astrisk'>*</span></label>
                                            <input type="date" className="form-control" min={today}
                                                value={startDate}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setStartDate(value);

                                                    // Reset end date if it's less than new start date
                                                    if (endDate && endDate < value) {
                                                        setEndDate("");
                                                    }
                                                }} />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <label className="form-labell">End Date<span className='astrisk'>*</span></label>
                                            <input type="date" className="form-control" min={startDate || today}
                                                value={endDate}
                                                disabled={!startDate}
                                                onChange={(e) => setEndDate(e.target.value)} />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-labell">Exam Start Date </label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={examStartDate}
                                                min={startDate || today}          // Cannot be before timeline start
                                                max={endDate || ""}               // Cannot be after timeline end
                                                disabled={!startDate || !endDate} // Only enable if timeline is selected
                                                onChange={(e) => setExamStartDate(e.target.value)}
                                            />
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>


                        {/* 3. Authentication */}
                        {/* <div className="card mb-2">
                        <button
                            className="card-header text-left activityCardHeader"
                            data-toggle="collapse"
                            data-target="#accAuth"
                            aria-expanded={accordion.accAuth}
                        // onClick={() => toggle("accAuth")}
                        >
                            <strong>Authentication</strong>
                         
                        </button>

                        <div
                            id="accAuth"
                            className={`collapse ${accordion.accAuth ? "show" : ""}`}
                            data-parent="#accordion"
                        >
                            <div className="card-body">
                                <label className="form-labell">Authenticate Student<span className='astrisk'>*</span></label>
                                <div className="d-flex flex-wrap gap-3">
                                    <label className="mr-3 form-labell">
                                        <input type="checkbox"
                                            checked={authMethods.includes('OTP')}
                                            onChange={() => toggleAuthMethod('OTP')} /> &nbsp; OTP
                                    </label>
                                    <label className="mr-3 form-labell">
                                        <input type="checkbox"
                                            checked={authMethods.includes('Biometric')}
                                            onChange={() => toggleAuthMethod('Biometric')} /> &nbsp; Biometric
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div> */}


                        {/* 4. Pre-checks */}

                        {/* <div className="card mb-2">
                        <button
                            className="card-header text-left activityCardHeader"
                            data-toggle="collapse"
                            data-target="#acc3"
                            aria-expanded={accordion.acc3}
                        // onClick={() => toggle("acc3")}
                        >
                            <strong> Pre-checks</strong>
                          
                        </button>

                        <div
                            id="acc3"
                            className={`collapse ${accordion.acc3 ? "show" : ""}`}
                            data-parent="#accordion"
                        >
                            <div className="card-body d-flex gap-5">

                                <label className="form-labell">Pre-checks Required<span className='astrisk'>*</span></label> */}


                        {/* <div className="d-flex">
                      <label className="form-labell">
                        <input
                          type="checkbox"
                          checked={preChecks.includes("NOC Clearance")}
                          onChange={() => togglePreCheck("NOC Clearance")}
                        />
                        &nbsp; NOC Clearance
                      </label>
                    </div> */}
                        {/* NEW → Library NOC Clearance */}

                        {/* <div>
                                    <label className="form-labell">
                                        <input
                                            type="checkbox"
                                            checked={preChecks.includes("Library NOC Clearance")}
                                            onChange={() => togglePreCheck("Library NOC Clearance")}
                                        />
                                        &nbsp; Library NOC Clearance
                                    </label>
                                </div> */}
                        {/* No Dues Clearance */}
                        {/* <div>
                                    <label className="form-labell">
                                        <input
                                            type="checkbox"
                                            checked={preChecks.includes("No Dues Clearance")}
                                            onChange={() => togglePreCheck("No Dues Clearance")}
                                        />
                                        &nbsp; No Dues Clearance
                                    </label>
                                </div> */}
                        {/* </div>
                        </div>
                    </div> */}

                        {/* 6. Assignment */}
                        <div className="card mb-2">
                            <button
                                className="card-header text-left activityCardHeader"
                                data-toggle="collapse"
                                data-target="#acc5"
                                aria-expanded={accordion.acc5}
                            // onClick={() => toggle("acc5")}
                            >
                                <strong> Assignment</strong>
                                {/* <span className="acc-icon">
                                {accordion.acc5 ? "−" : "+"}
                            </span> */}
                            </button>

                            <div
                                id="acc5"
                                className={`collapse ${accordion.acc5 ? "show" : ""}`}
                                data-parent="#accordion"
                            >
                                <div className="card-body">
                                    <label>Assign Employees<span className='astrisk'>*</span></label>

                                    <div className="form-controls mt-2" style={{ minHeight: "40px" }}>
                                        {/* Replace with react-select */}
                                        <Select
                                            classNamePrefix="select"
                                            isSearchable
                                            isMulti
                                            name="employee"

                                            // OPTIONS FROM API
                                            options={assignedEmployees?.map(emp => ({
                                                value: emp.employee_id,   // FIXED
                                                label: emp.name,
                                            }))}

                                            placeholder="-- Select Employee --"

                                            // VALUE MUST MATCH OPTIONS FORMAT
                                            value={assignedEmployees
                                                ?.map(emp => ({
                                                    value: emp.employee_id, // FIXED
                                                    label: emp.name,
                                                }))
                                                .filter(option => selectedEmployeeIds.includes(option.value))
                                            }

                                            // ONCHANGE — ONLY STORE IDS
                                            onChange={(selectedOptions) => {
                                                setSelectedEmployeeIds(selectedOptions.map(opt => opt.value));
                                            }}

                                            menuPortalTarget={document.body}
                                            styles={{
                                                ...reactSelectStyles,
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            }}

                                            menuPlacement="auto"
                                        />

                                    </div>

                                    <small className="text-muted d-block mt-2">
                                        You can assign multiple employees for this activity.
                                    </small>
                                </div>
                            </div>
                        </div>


                        {selectedStudent.length > 0 && (
                            <div className="mt-3 p-3 d-flex justify-content-end"
                            // style={{ background: '#fafafa' }}
                            >
                                <div className="mt-3 d-flex gap-2 justify-content-end">
                                    {/* <button
                                    className="add-btn"
                                    style={{ display: 'flex', alignItems: 'center', gap: "10px" }}
                                    disabled={selectedStudent.length === 0}
                                    // onClick={() =>
                                    // onNext({
                                    // courseData,
                                    // semesterData,
                                    // section,
                                    // selectedStudent,
                                    onClick={handleCalculativeSubmit}
                                // })
                                // }

                                >
                                    Next <img src={next} alt="next" />
                                </button> */}
                                </div>
                                {!editId && (<button className="add-btn" onClick={handleCalculativeSubmit} disabled={loading}
                                    style={{
                                        opacity: isDisabled ? 0.5 : 1,
                                        cursor: isDisabled ? "not-allowed" : "pointer",
                                    }}>
                                    {loading ? (
                                        <span className="spinner-border spinner-border-sm" role="status" />
                                    ) : (
                                        "Save & Continue"
                                    )}
                                </button>)}
                            </div>
                        )}
                    </div>
                    <div className='row'>
                        <div className='col-md-12 d-flex justify-content-end'>
                            {editId && (<button className="add-btn" onClick={handleUpdate}>
                                {loading ? (
                                    <span className="spinner-border spinner-border-sm" role="status" />
                                ) : (
                                    "Update Activity"
                                )}
                            </button>)}</div>
                    </div>
                </div>
            </div >
        </>
    );
};

export default SelectStudents













